import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"

const RelatedWorkPosts = ({workSectors}) => {
  // const { allWpWorkSector } = useStaticQuery(
  //   graphql`
  //     query GetAllWorkSectors {
  //       allWpWorkSector(
  //         filter: {
  //           slug: "commercial"
  //         }
  //       ) {
  //         nodes {
  //           name
  //           workPosts {
  //             edges {
  //               node {
  //                 title
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   `
  // )
  // const { wp } = useStaticQuery(
  //   graphql`
  //     query RelatedWorkPosts {
  //       allWpWork(
  //         where: {taxQuery: {taxArray: {terms: "commercial", taxonomy: WORKSECTOR}}}
  //       ) {
  //         edges {
  //           node {
  //             id
  //             title
  //             uri
  //           }
  //         }
  //       }
  //     }
  //   `
  // )
  // // allWpWork(
  // //   sort: { fields: [date], order: DESC }
  // //   limit: $postsPerPage
  // //   skip: $offset
  // // ) {
  return (
    <section className="hidden">
      <p>Like this?<br/>Well you’re gonna love these</p>
    </section>
  )
}

export default RelatedWorkPosts
